import {
  PrimaryButton,
  SecondaryButton,
} from "@JohnLewisPartnership/jl-design-system/dist/elements/button/Button";
import { Message } from "@JohnLewisPartnership/jl-design-system/dist/components/message/Message";
import { ExpressCheckoutOutlined } from "@JohnLewisPartnership/jl-design-system/dist/components/icons/ExpressCheckoutOutlined";
import styles from "./ExpressCheckoutButton.module.scss";

type ExpressCheckoutButtonProps = {
  disabled: boolean;
  isShipFromStore: boolean;
  asPrimaryButton: boolean;
  isSubmitting: boolean;
  handleAddToBasketClick: () => void;
};

export const ExpressCheckoutButton = ({
  disabled,
  isShipFromStore,
  asPrimaryButton = false,
  handleAddToBasketClick,
  isSubmitting,
}: ExpressCheckoutButtonProps) => {
  const ButtonComponent = asPrimaryButton ? PrimaryButton : SecondaryButton;

  return (
    <div className={styles.container}>
      {!isShipFromStore && (
        <Message
          type="information"
          title=" "
          body="You can only buy this item on its own, any other items in your basket will be saved. Delivery and payment methods are available when you continue to checkout."
        />
      )}

      <ButtonComponent
        disabled={disabled}
        submitting={isSubmitting}
        onClick={handleAddToBasketClick}
        className={styles.button}
        data-testid="basket:add:express"
      >
        <ExpressCheckoutOutlined />
        Express checkout
      </ButtonComponent>
    </div>
  );
};
